import { useNavigate } from "react-router-dom";
import { AdminButton } from "@/components/admin";
interface SoundDetailHeaderProps {
    recordId: number;
    elderlyName: string;
    elderlyIdLabel: string;
    riskLabel: string;
    riskTone: "success" | "warning" | "danger" | "neutral";
    soundType: string;
    deviceName: string;
    analyzedAt: string;
}
const toneStyle = {
    success: {
        badge: "bg-emerald-100 text-emerald-700 border-emerald-300",
        dot: "bg-emerald-500",
        header: "bg-white border-slate-200",
    },
    warning: {
        badge: "bg-orange-100 text-orange-700 border-orange-300",
        dot: "bg-orange-500",
        header: "bg-orange-50 border-orange-200",
    },
    danger: {
        badge: "bg-red-100 text-red-700 border-red-300",
        dot: "bg-red-500",
        header: "bg-red-50 border-red-200",
    },
    neutral: {
        badge: "bg-slate-100 text-slate-700 border-slate-300",
        dot: "bg-slate-400",
        header: "bg-white border-slate-200",
    },
};
const SoundDetailHeader = ({ recordId, elderlyName, elderlyIdLabel, riskLabel, riskTone, soundType, deviceName, analyzedAt, }: SoundDetailHeaderProps) => {
    const navigate = useNavigate();
    const style = toneStyle[riskTone];
    return (<div className={`rounded-xl border ${style.header} px-5 py-4`}>
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-4">
          <AdminButton variant="secondary" size="icon" aria-label="소리 분석 목록으로" onClick={() => navigate("/admin/sound-analysis")} className="mt-0.5 h-8 w-8 flex-shrink-0 shadow-sm">
            <i className="ri-arrow-left-line text-sm"/>
          </AdminButton>
          <div>
            <div className="flex items-center gap-2 flex-wrap">
              <span className="text-xs text-slate-400 font-medium">소리 분석 상세</span>
              <span className="text-xs text-slate-300">·</span>
              <span className="text-xs text-slate-400 font-mono">SA-{recordId}</span>
            </div>
            <div className="flex items-center gap-2 mt-0.5 flex-wrap">
              <h1 className="text-xl font-bold text-slate-800">{elderlyName}</h1>
              <span className="text-sm text-slate-500">어르신 ID {elderlyIdLabel}</span>
            </div>
            <div className="flex items-center gap-2 mt-1 flex-wrap">
              <span className="text-xs text-slate-500">{analyzedAt}</span>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-semibold border bg-slate-100 text-slate-700 border-slate-200">
            {soundType}
          </span>
          <span className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-semibold border ${style.badge}`}>
            <span className={`w-2.5 h-2.5 rounded-full ${style.dot}`}/>
            {riskLabel}
          </span>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4 mt-4 pt-4 border-t border-slate-100">
        <div className="flex flex-col gap-1">
          <span className="text-xs font-medium text-slate-400 uppercase tracking-wide">어르신</span>
          <span className="text-sm font-semibold text-slate-800">{elderlyName}</span>
        </div>
        <div className="flex flex-col gap-1">
          <span className="text-xs font-medium text-slate-400 uppercase tracking-wide">기기</span>
          <span className="text-sm text-slate-700">{deviceName}</span>
        </div>
        <div className="flex flex-col gap-1">
          <span className="text-xs font-medium text-slate-400 uppercase tracking-wide">분석 시각</span>
          <span className="text-sm text-slate-600">{analyzedAt}</span>
        </div>
      </div>
    </div>);
};
export default SoundDetailHeader;
